import React from 'react';
import Axios from 'axios';
import moment from 'moment';
import { Bar, Doughnut, Line, Pie, Polar, Radar } from 'react-chartjs-2';
import { Progress } from 'reactstrap';

import * as myConstClass from '../../shared/constants/constants';

class DashMod_Summary02 extends React.Component {

  constructor(props) {
		super(props);

		this.state = {
			stats: [],
			loading: true,
		};
	
		//this.dummyfunction = this.dummyfunction.bind(this);
	}

	componentDidMount() {
    //console.log('DashMod_Summary02: componentDidMount');
		this.loadData(this.props);
	}

  UNSAFE_componentWillReceiveProps(nextProps) {
	  //console.log('DashMod_Summary02: UNSAFE_componentWillReceiveProps');
	  this.setState({
	  	loading: true,
	  });
		this.loadData(nextProps);
  }

	loadData(props) {
		// console.log('DashMod Summary02 - loadData');
		var _this = this;

		// ##### add leagueId props.leagueId

	  // -1 = no season selected
		Axios.get('/api/dashmod/summary/playerId/' + props.playerId + 
			'/year/' + props.year + '/leagueId/' + props.leagueId + '/seasonId/' + props.seasonId + 
			'/resultsType/' + props.resultsType + '/leagueType/' + props.leagueType).
			then(function(response) {

				_this.setState({
					stats: response.data,
					loading: false,
				});
		});
	}

	render() {
		// console.log('DashMod_Summary02: render');
		return (
			<div className="row db-module-outer-light">
			<div className="col-12">

				<div className="row">
				<div className="col-12 text-center">
					<h4 className="db-module-title-light">Votre sommaire statistique</h4>
				</div>
				</div>

				<div className="row db-module-inner-light">
				<div className="col-md-12 db-module-inner-col-padding">
				<div className="card db-module-inner-card-light-cards">

				{this.state.loading ? 
					<div className="text-center"> 
						<i> données en chargement </i>
						{this.displaySpinner()}
					</div>
					: this.dispModules()}

				</div>
				</div>
				</div>

			</div>
			</div>
		)
	}

	dispModules() {
		if(this.props.leagueType !== myConstClass.LGTYPE_9B) {
			return (
				<div>
				<div className="row">
					{this.displayModuleVictoires()}
					{this.displayModulePartiesParEro()}
					{this.displayModuleIPS()}
				</div>
				<div className="row">
					{this.displayModuleSummaires()}
					{this.displayModulePerformances()}
				</div>
				</div>
			)
		} else {
			return (
				<div>
				<div className="row">
					{this.displayModuleVictoires()}
					{this.displayModuleSummaires()}
				</div>
				</div>
			)
		}
	}

	displayModuleVictoires() {
		var stats = this.state.stats;
		return (
			<div className="col-md-4">
     	<div className="card">
			<div className="card-header">
				<i className="fa fa-star"></i>
     		<span className="text-uppercase font-weight-bold">% Victoires</span>
			</div>

     	<div className="card-block p-1 clearfix">
      	<table><tbody>
      	<tr>
	      	<td><i className="fa fa-pie-chart fa-lg mt-4 bg-widget01 p-1 font-2xl mr-1"></i></td>
					<td>{this.dispIncDecValue(false, stats.total.winPct, "Total", "%", false, 1)}</td>
      	</tr>
				<tr>
	      	<td></td>
					<td>{this.dispIncDecValue(true, stats.lastWeek.winPctVar, "Dernière semaine", "%", false, 1)}</td>
      	</tr>
      	<tr>
	      	<td></td>
					<td>{this.dispIncDecValue(true, stats.lastMonth.winPctVar, "Dernier mois", "%", false, 1)}</td>
      	</tr>

				</tbody></table>
				</div>
    	</div>
    	</div>
		);
	}

	displayModulePartiesParEro() {
		var stats = this.state.stats;
		var eroText = "ERO";
		if(this.props.leagueType === myConstClass.LGTYPE_10B) {
			eroText = "TRO";
		}

		return (
			<div className="col-md-4">
     	<div className="card">
			<div className="card-header">
				<i className="fa fa-star"></i>
     		<span className="text-uppercase font-weight-bold">Parties par {eroText}</span>
			</div>

     	<div className="card-block p-1 clearfix">
    	<table><tbody>
	  	<tr>
		  	<td><i className="fa fa-star fa-lg mt-4 bg-widget01 p-1 font-2xl mr-1"></i></td>
				<td>{this.dispIncDecValue(false, stats.total.eroRate, "Total", "parties", true, 1)}</td>
    	</tr>
    	<tr>
	    	<td></td>
				<td>{this.dispIncDecValue(true, stats.lastWeek.eroRateVar, "Dernière semaine", "", true, 1)}</td>
    	</tr>
    	<tr>
	    	<td></td>
				<td>{this.dispIncDecValue(true, stats.lastMonth.eroRateVar, "Dernier mois", "", true, 1)}</td>
    	</tr>

			</tbody></table>
			</div>
    	</div>
    	</div>
		);
	}

	displayModuleIPS() {
		var stats = this.state.stats;
		return (
			<div className="col-md-4">
     	<div className="card no-margin-bottom">
			<div className="card-header">
				<i className="fa fa-star"></i>
     		<span className="text-uppercase font-weight-bold">IPS</span><br/>
			</div>

     	<div className="card-block p-1 clearfix">
      	<table><tbody>
      	<tr>
		    	<td><i className="fa fa-pie-chart fa-lg mt-4 bg-widget01 p-1 font-2xl mr-1"></i></td>
					<td>{this.dispIncDecValue(false, stats.total.ips, "Total", "", false, 0)}</td>
      	</tr>
      	<tr>
	      	<td></td>
					<td>{this.dispIncDecValue(true, stats.lastWeek.ipsVar, "Dernière semaine", "", false, 0)}</td>
      	</tr>
      	<tr>
	      	<td></td>
					<td>{this.dispIncDecValue(true, stats.lastMonth.ipsVar, "Dernier mois", "", false, 0)}</td>
      	</tr>
				</tbody></table>
				</div>
    	</div>
			<i>* IPS: Indice de Performance Statelo</i><br/><br/>
    	</div>
		);
	}

	displayModuleSummaires() {
		var stats = this.state.stats;
		return (
			<div className="col-md-6">
			<div className="card">
				<div className="card-header">
					<i className="fa fa-th-large"></i>
       		<span className="text-uppercase font-weight-bold">Statistiques sommaires</span>
				</div>

				<div className="card-block card-body">
					<div className="table-responsive">
					<table className="table table-striped table-hover table-sm">
					<thead>
						<tr>
							<th></th>
							<th>Total</th>
							<th>Sem</th>
							<th>Mois</th>
						</tr>
					</thead>

					<tbody>
						<tr>
							<td>Parties jouées</td>
							<td>{stats.total.games}</td>
							<td>{stats.lastWeek.games}</td>
							<td>{stats.lastMonth.games}</td>
						</tr>
						<tr>
							<td>Victoires</td>
							<td>{stats.total.wins}</td>
							<td>{stats.lastWeek.wins}</td>
							<td>{stats.lastMonth.wins}</td>
						</tr>
						<tr>
							<td>Défaites</td>
							<td>{stats.total.losts}</td>
							<td>{stats.lastWeek.losts}</td>
							<td>{stats.lastMonth.losts}</td>
						</tr>
						<tr>
							<td>% victoires</td>
							<td>{stats.total.winPct.toFixed(1) + "%"}</td>
							<td>{stats.lastWeek.winPct.toFixed(1) + "%"}</td>
							<td>{stats.lastMonth.winPct.toFixed(1) + "%"}</td>
						</tr>
						<tr>
							<td>IPS</td>
							<td>{stats.total.ips}</td>
							<td>{stats.lastWeek.ips}</td>
							<td>{stats.lastMonth.ips}</td>
						</tr>

					</tbody>
					</table>
					</div>
				</div>
			</div>
			</div>
		);
	}

	displayModulePerformances() {
		var stats = this.state.stats;
		var dispTV = true;
		var eroText = "ERO";
		if(this.props.leagueType === myConstClass.LGTYPE_10B) {
			dispTV = false;
			eroText = "TRO";
		}

		return (
			<div className="col-md-6">
			<div className="card">
				<div className="card-header">
					<i className="fa fa-th-large"></i>
       		<span className="text-uppercase font-weight-bold">Performances</span>
				</div>

				<div className="card-block card-body">
					<div className="table-responsive">
					<table className="table table-striped table-hover table-sm">
					<thead>
						<tr>
							<th></th>
							<th>Total</th>
							<th>Sem</th>
							<th>Mois</th>
						</tr>
					</thead>

					<tbody>
						<tr>
							<td>{eroText} pour</td>
							<td>{stats.total.ero}</td>
							<td>{stats.lastWeek.ero}</td>
							<td>{stats.lastMonth.ero}</td>
						</tr>
						<tr>
							<td>{eroText} contre</td>
							<td>{stats.total.eroContre}</td>
							<td>{stats.lastWeek.eroContre}</td>
							<td>{stats.lastMonth.eroContre}</td>
						</tr>

						{dispTV ?
						<tr>
							<td>TV pour</td>
							<td>{stats.total.tv}</td>
							<td>{stats.lastWeek.tv}</td>
							<td>{stats.lastMonth.tv}</td>
						</tr>
						: null}
						{dispTV ?
						<tr>
							<td>TV contre</td>
							<td>{stats.total.tvContre}</td>
							<td>{stats.lastWeek.tvContre}</td>
							<td>{stats.lastMonth.tvContre}</td>
						</tr>
						: null}

					</tbody>
					</table>
					</div>


				</div>
			</div>
			</div>
		);
	}

	dispIncDecValue(dispArrow, value, subText, symbolText, reverseColor, nbDecimals) {
		var arrowClassName = "";
		var textColor = "text-good-value";

		if (dispArrow) {
			if (value > 0) {
				if (!reverseColor) {
					textColor = "text-good-value";
					arrowClassName = "fa fa-arrow-up " + textColor;
				} else {
					textColor = "text-bad-value";
					arrowClassName = "fa fa-arrow-up " + textColor;
				}
			}
			if (value < 0) {
				if (!reverseColor) {
					textColor = "text-bad-value";
					arrowClassName = "fa fa-arrow-down " + textColor;
				} else {
					textColor = "text-good-value";
					arrowClassName = "fa fa-arrow-down " + textColor;
				}
			}
			if (Math.round(value * 10) / 10 === 0) {
				textColor = "text-good-value";
				arrowClassName = "fa fa-arrow-right " + textColor;
			}
		}
		value = Math.abs(value).toFixed(nbDecimals);

		return (
			<div>
				<div className={"h5 " + textColor + " mb-0 mt-h"}><span className={arrowClassName}></span> {value} {symbolText}</div>
				<div className="text-muted-widget01 text-uppercase font-weight-bold font-xs">{subText}</div>
			</div>
		);
	}

	displaySpinner() {
		return (
  		<div className="sk-three-bounce">
    		<div className="sk-child sk-bounce1"></div>
    		<div className="sk-child sk-bounce2"></div>
    		<div className="sk-child sk-bounce3"></div>
  		</div>
  	);
	}

}

export default DashMod_Summary02;
